import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  AddressModel,
  ClientBasicModel,
  ClientFullModel,
  ClientModel,
  ClientPropertyModel,
  ClientRequest,
  ClientResourceService,
  CommentModel,
  CompanyModel,
  ContactModel,
  PagedClientFullModel,
  SaveClientPropertyRequest,
  SaveResult,
  SortType
} from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxClientService {
  constructor(
    private clientResourceService: ClientResourceService
  ) {
  }

  getClientById(id: number): Promise<ClientFullModel> {
    return firstValueFrom(this.clientResourceService.getClientById(id));
  }

  searchClient(searchText: string): Promise<ClientBasicModel[]> {
    return firstValueFrom(this.clientResourceService.searchClients(undefined, searchText));
  }

  getClientList(params?: {
    page?: number;
    orderBy?: string,
    limit?: number,
    phone?: string,
    query?: string,
    sort?: SortType,
    storeIds?: number[],
    brandId?: number,
    countryId?: number,
    birthDay?: number,
    birthMonth?: number
  }): Promise<PagedClientFullModel> {
    return firstValueFrom(this.clientResourceService.getClients(params?.birthDay, params?.birthMonth, params?.limit, params?.orderBy, params?.page, params?.phone, params?.query, params?.sort, params?.storeIds, params?.brandId, params?.countryId));
  }

  getClientByPhone(phone: string): Promise<ClientFullModel> {
    return firstValueFrom(this.clientResourceService.getClientByPhone(phone));
  }

  getClient(id: number): Promise<ClientFullModel> {
    return firstValueFrom(this.clientResourceService.getClientById(id));
  }

  getClientBrandProperties(id: number): Promise<ClientPropertyModel[]> {
    return firstValueFrom(this.clientResourceService.getClientProperties(id));
  }

  saveClientBrandProperty(id: number, body: SaveClientPropertyRequest): Promise<SaveResult> {
    return firstValueFrom(this.clientResourceService.saveClientProperty(id, body));
  }

  removeClientBrandProperty(id: number): Promise<any> {
    return firstValueFrom(this.clientResourceService.removeClientProperty(id));
  }

  removeAddress(id: number): Promise<any> {
    return firstValueFrom(this.clientResourceService.removeClientAddress(id));
  }

  saveClient(request: ClientRequest): Promise<ClientModel> {
    return firstValueFrom(this.clientResourceService.saveClient(request));
  }

  getClientCompanies(params: { clientId?: number }): Promise<CompanyModel[]> {
    return firstValueFrom(this.clientResourceService.getClientCompanies(params.clientId as number));
  }

  getClientComments(clientId: number): Promise<CommentModel[]> {
    return firstValueFrom(this.clientResourceService.getClientComments(clientId));
  }

  buildRequest(client?: { client: ClientModel, additionalAddresses: AddressModel[], additionalContacts: ContactModel[] }): ClientRequest {
    let request: ClientRequest = { phone: ''};
    if (client) {
      request.id = client.client.id;
      request.phone = client.client.phone;
      request.birthDate = client.client.birthDate;
      request.countryId = client.client.countryId;
      request.fullname = client.client.fullname;
      request.additionalAddresses = client.additionalAddresses.map(address => ({...address}));
      request.additionalContacts = client.additionalContacts.map(contact => ({...contact}));
    }
    return request;
  }
}
